import popup from "./Common/popup";
import StaffData from "./StaffData";
import { combineReducers } from 'redux';
import InvoiceReducer from "./InvoiceReducer";
import ProductReducer from "./Common/ProductReducer";
import CommandsReducer from './Common/CommandsReducer';
import locationDataReducer from './location/locationData';
import customerDataReducer from './customer/CustomerData';
import SystemSettingsReducer from './Common/SystemSettings';
import ProductRequestReducer from "./ProductRequest/ProductRequestForService";
import ReportReducer from "./ReportsReducer";


const reducers = combineReducers({
  
  popup,
  StaffData,
  ReportReducer,
  ProductReducer,
  InvoiceReducer,
  CommandsReducer,  
  customerDataReducer,
  locationDataReducer,
  ProductRequestReducer,
  SystemSettingsReducer
  
})


export default reducers;